import { render, staticRenderFns } from "./Case1.vue?vue&type=template&id=44c546ea&scoped=true"
import script from "./Case1.vue?vue&type=script&lang=js"
export * from "./Case1.vue?vue&type=script&lang=js"
import style0 from "./Case1.vue?vue&type=style&index=0&id=44c546ea&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c546ea",
  null
  
)

export default component.exports